import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";

@Component({
	selector: "app-book-inventory-barcode",
	templateUrl: "./book-inventory-barcode.component.html",
	styleUrls: ["./book-inventory-barcode.component.css"],
})
export class BookInventoryBarcodeComponent implements OnInit {
	constructor(private selectService: SchoolselectorService, private reportService: ReportService, private dialogService: DialogService) {}

	report = {
		SchoolID: 0,
		StudentActiveID: -1,
		BookSubjectID: 0,
		BookTitleID: 0,
		BookStatusID: 0,
		OrderByID: "Subject",
		SortOrderID: "ASC",
	};

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	lstBookSubject: any = [];
	lstBookTitle: any = [];
	lstBookStatus: any = [];

	lstActive: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	lstOrderBy = [
		{
			OrderByID: "School",
			OrderByDesc: "School",
		},
		{
			OrderByID: "FirstName",
			OrderByDesc: "Student First Name",
		},
		{
			OrderByID: "LastName",
			OrderByDesc: "Student Last Name",
		},
		{
			OrderByID: "PersonActive",
			OrderByDesc: "Student Active",
		},
		{
			OrderByID: "Title",
			OrderByDesc: "Title",
		},
		{
			OrderByID: "Author",
			OrderByDesc: "Author",
		},
		{
			OrderByID: "Subject",
			OrderByDesc: "Subject",
		},
		{
			OrderByID: "ISBN",
			OrderByDesc: "ISBN",
		},
		{
			OrderByID: "Barcode",
			OrderByDesc: "Barcode",
		},
		{
			OrderByID: "Price",
			OrderByDesc: "Price",
		},
	];

	lstSortOrder: any = [
		{
			ID: "ASC",
			Desc: "Ascending",
		},
		{
			ID: "DESC",
			Desc: "Descending",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 436;
	subscription: any;

	ngOnInit() {
		this.BookStatusList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;

		this.BookSubjectList();
	}

	BookSubjectList() {
		this.report.BookSubjectID = 0;
		var result = this.reportService.BookSubjectGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.lstBookSubject = response;

				this.lstBookSubject.unshift({
					BookSubjectID: 0,
					BookSubjectName: "All Subjects",
				});

				this.report.BookSubjectID = this.lstBookSubject[0].BookSubjectID;

				this.BookTitleList();
			},
			(error) => {}
		);
	}

	BookTitleList() {
		this.report.BookTitleID = 0;
		var result = this.reportService.BookTitleGetList(this.report.BookSubjectID, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.lstBookTitle = response;

				this.lstBookTitle.unshift({
					BookTitleID: 0,
					BookTitle: "All Titles",
				});

				this.report.BookTitleID = this.lstBookTitle[0].BookTitleID;
			},
			(error) => {}
		);
	}

	BookStatusList() {
		this.report.BookStatusID = 0;
		var result = this.reportService.BookStatusGetList();
		result.subscribe(
			(response) => {
				this.lstBookStatus = response;

				this.lstBookStatus.unshift({
					BookStatusID: 0,
					StatusName: "Any Status",
				});

				this.report.BookStatusID = this.lstBookStatus[0].BookStatusID;
			},
			(error) => {}
		);
	}

	onBookSubjectChange(val) {
		this.report.BookSubjectID = val;

		this.BookTitleList();
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		// if (!this.report.SchoolID) {
		//     this.errorMessage = "Select the School";
		//     return
		// }

		this.isProcessing = true;

		var strParam = this.GetStrParam();

		// @StudentActive
		// @BookSubjectID
		// @BookTitleID
		// @BookStatusID
		// @OrderBy
		// @SortOrder
		// @SchoolID

		var reportID = 436;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);
		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		strParam += this.report.StudentActiveID + "|StudentActive";
		strParam += "," + this.report.BookSubjectID + "|BookSubjectID";
		strParam += "," + this.report.BookTitleID + "|BookTitleID";
		strParam += "," + this.report.BookStatusID + "|BookStatusID";
		strParam += "," + this.report.OrderByID + "|OrderBy";
		strParam += "," + this.report.SortOrderID + "|SortOrder";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
